import '../../styles/HomeComponents/Demo.css'
function Demo() {
    return ( 
        <div className='demo'>
            <div>
                <h2>Understanding Strawket</h2>
                <p>Strawket is a simple, powerful digital learning hub where exceptional teachers and curious learners meet. 
                It is an intelligent platform designed to spark creativity, nurture talent, and transform learning into an extraordinary experience. With Strawket, curiosity finds direction, and potential turns into success.</p>
            </div>
            <div className='video-container'>
                {/* <video src={video} controls></video> */}
                 <div className="responsive-iframe">
                    <iframe
                        src="https://www.youtube.com/embed/C8hot_tYL9Q"
                        title="Strawket Demo"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="eager"
                    ></iframe>
                </div>
            </div>
        </div>
     );
}

export default Demo;